import { render, staticRenderFns } from "./GameHome.vue?vue&type=template&id=7763ea80"
import script from "./GameHome.vue?vue&type=script&lang=ts"
export * from "./GameHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports